var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleCoreWebVitalsForBusinessOwners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gcorewebvital",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wcorewebvital",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F6560",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ocorewebvital",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#163936"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wcorewebvital)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#ocorewebvital)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 150 461.2900600582361 C 400 391.2900600582361 560 531.2900600582361 800 419.2900600582361 S 1080 391.2900600582361 1120 377.2900600582361",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.5,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 507.2900600582361 C 400 425.2900600582361 560 589.2900600582361 800 458.09006005823613 S 1080 425.2900600582361 1120 408.89006005823614",
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.85,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 553.2900600582361 C 400 459.2900600582361 560 647.2900600582361 800 496.89006005823614 S 1080 459.2900600582361 1120 440.4900600582361",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.36,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 599.2900600582361 C 400 493.2900600582361 560 705.2900600582361 800 535.6900600582361 S 1080 493.2900600582361 1120 472.09006005823613",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.29,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 645.2900600582361 C 400 527.2900600582361 560 763.2900600582361 800 574.4900600582362 S 1080 527.2900600582361 1120 503.6900600582361",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.22,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 570,
    width: 34,
    height: 70,
    rx: 17,
    fill: "url(#gcorewebvital)",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 522,
    width: 34,
    height: 118,
    rx: 17,
    fill: "url(#gcorewebvital)",
    fillOpacity: 0.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 474,
    width: 34,
    height: 166,
    rx: 17,
    fill: "url(#gcorewebvital)",
    fillOpacity: 0.61
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 426,
    width: 34,
    height: 214,
    rx: 17,
    fill: "url(#gcorewebvital)",
    fillOpacity: 0.74
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 378,
    width: 34,
    height: 262,
    rx: 17,
    fill: "url(#gcorewebvital)",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleCoreWebVitalsForBusinessOwners);
export default __webpack_public_path__ + "static/media/article-core-web-vitals-for-business-owners.bac6823f32427b2552a3e15b46ee0024.svg";
export { ForwardRef as ReactComponent };